import React, { Component } from 'react';
import Segment from '../segment/Segment';
import Welcome from '../welcome/Welcome';
import content from '../content/content.js';
import './App.css';

class App extends Component {
  constructor(props) {
    super();
    this.segments = content.map(segment =>
      <Segment
        id={segment.id}
        intro={segment.intro}
        headline={segment.headline}
        subHeadline={segment.subHeadline}
        description={segment.description}
        buttons={segment.buttons}
        buttonComment={segment.buttonComment}
        width={segment.width}
        img={segment.img}
        video={segment.video}
        key={segment.id}
      />);

  }
  render() {
    return (
      <div className="App">
        <div className="container">
          <div className="row">
           <Welcome /> 
          </div>
          <div className="row">
            {this.segments}
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js